module.exports = __webpack_public_path__ + "footer-bg.a3ff577ca05c73ae9b94.jpg";


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/assets/images/footer-bg.jpg
// module id = ../../../../../src/assets/images/footer-bg.jpg
// module chunks = 2